export default __webpack_public_path__ + "static/media/Bandit's Wristbands of the Covert Trail.6e4ccf15.jpg";